 $(document).ready(function(){
      // Filters
  if(window.location.pathname.split('/').length < 4){
//     $(".filter select").each(function(index,el){
//       $(el).prop('selectedIndex',0);
//     });
    //console.log('-1111-1111');
    var selects = $(".filter-c select");
    //console.log(selects);
    for(var i=0;i<selects.length-1;i++){
      //$(selects[i]).prop('selectedIndex',0);
    }

    localStorage.removeItem('jewelryType');
    localStorage.removeItem('designer');
    localStorage.removeItem('material');
    localStorage.removeItem('gemstone');
    localStorage.removeItem('priceRange');

    var url = ["", "", "", "", ""];

  }else{
   console.log('mobile is here');
   var jewelryType =localStorage.getItem('jewelryType');
   $(".filters-mobile .filter-type select").val(jewelryType);
   var designer =localStorage.getItem('designer');
   $(".filters-mobile .filter-designers select").val(designer);
   var material =localStorage.getItem('material');
   $(".filters-mobile .filter-materials select").val(material);
   var gemstone =localStorage.getItem('gemstone');
   $(".filters-mobile .filter-gemstones select").val(gemstone);
   var priceRange =localStorage.getItem('priceRange');
   $(".filters-mobile .filter-price select").val(priceRange);

   var url = [jewelryType, designer, material, gemstone, priceRange];
  }


    $(".filters-mobile .filter-c select").change(function(){
      console.log('option changed!');
      if($(this).parent().hasClass('filter-type')){
        jewelryType = $(this).val();
        url[0] = jewelryType;
        localStorage.setItem('jewelryType', jewelryType);
      }else if($(this).parent().hasClass('filter-designers')){
        designer = $(this).val();
        url[1] = designer.replace('/ ', '');
        localStorage.setItem('designer', designer);
      }else if($(this).parent().hasClass('filter-materials')){
        material = $(this).val();
        url[2] = material;
        localStorage.setItem('material', material);
      }else if($(this).parent().hasClass('filter-gemstones')){
        gemstone = $(this).val();
        url[3] = gemstone;
        localStorage.setItem('gemstone', gemstone);
      }else if($(this).parent().hasClass('filter-price')){
        priceRange = $(this).val();
        url[4] = priceRange;
        localStorage.setItem('priceRange', priceRange);
      }

     var filteredUrl1 = url.filter(Boolean);
     var filteredUrl2 = [];
//      console.log(filteredUrl1);
     $.each(filteredUrl1, function(i, el){
       el = el.replace(/ /g,"-");
       filteredUrl2.push(el);
     });
//      console.log(filteredUrl2);
     filteredUrl = filteredUrl2.join("+");
     var path1 = window.location.pathname.split('/').slice(1,3).join('/');
     newUrl = window.location.origin + '/' + path1 + '/' + filteredUrl + '?view=mobile';
     console.log(newUrl);
     window.location.href = newUrl;

    });
  })
